<div class="loading" [ngClass]="{hidden: !loading}">
    <div class="admin-progress admin-progress--indeterminate admin-progress--primary-strong admin-progress--top-edge"></div>
</div>
<router-outlet></router-outlet>
